const BASE_URL = '/api/v1/ask-vantage/tts';

const generateTTS = async (text: string): Promise<ArrayBuffer> => {
  if (!text || text.trim().length === 0) {
    throw new Error('Text cannot be empty');
  }

  try {
    // Get JWT token from localStorage (same as rmsApi interceptor)
    const token = localStorage.getItem('jwt');
    const headers: HeadersInit = {
      'Content-Type': 'application/json'
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${BASE_URL}/generate`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ text })
    });

    if (!response.ok) {
      throw new Error(`TTS generation failed: ${response.status} ${response.statusText}`);
    }

    const arrayBuffer = await response.arrayBuffer();

    if (arrayBuffer.byteLength === 0) {
      throw new Error('Received empty audio data');
    }

    return arrayBuffer;
  } catch (error) {
    console.error('Error generating TTS:', error);
    throw error;
  }
};

export default generateTTS;
